/*
  BUTTOM 18/10/2026: costo y plazo del envío a partir del CÓDIGO POSTAL de la persona.
  Se carga en todas las páginas desde layout/theme.liquid (el carrito lateral puede aparecer en cualquiera).

  Por qué código postal y no "provincia adivinada por la conexión" (versión anterior):
    - La conexión decía de dónde sale internet, no dónde está la persona (desde CABA solía dar
      "Buenos Aires"), y el checkout de Shopify PRELLENA provincia y código postal con la última
      estimación de envío: la gente de CABA terminaba pagando el envío de provincia.
    - Con el código postal la provincia sale sin error (1000 a 1499 = CABA) y el checkout queda
      prellenado con el código postal REAL del cliente.

  Cómo decide (en este orden):
    1. El código postal que la persona escribió (queda guardado en su navegador: buttom_cp).
    2. El de la dirección de su cuenta de la tienda, si inició sesión (data-cp-cuenta).
    3. Si no hay código postal: no se calcula nada ni se llama a Shopify. Se muestra la línea
       "Envío a todo el país · Gratis desde $80.000" con un "Calcular" para escribirlo.

  Código postal → provincia: tabla completa (1000 a 9999) dentro de este mismo archivo (RANGOS_CP),
  sin pedidos a otros servidores.

  Precios: con productos en el carrito salen de Shopify (Configuración > Envíos), así que si
  cambian las tarifas se actualizan solos. Con el carrito vacío (ficha del producto antes de
  agregar) se usa TABLA_RESPALDO: si cambian las tarifas, actualizar también esa tabla.
*/
(function () {
  if (!window.customElements || window.customElements.get('buttom-calcula-envio')) return;

  var ENVIO_GRATIS_DESDE = 8000000; // $80.000 en centavos, antes de descuentos (igual que la app Hoppy)
  var CLAVE_CP = 'buttom_cp';       // código postal escrito por la persona
  var TIMEOUT_PROPIO_MS = 6000;

  var CABA = 'Ciudad Autónoma de Buenos Aires';
  var TEXTO_SIN_CP = 'Envío a todo el país · Gratis desde $80.000';

  // Nombres EXACTOS de provincia que usa Shopify Argentina (para prellenar bien el checkout).
  var PROVINCIAS = [CABA, 'Buenos Aires', 'Catamarca', 'Chaco', 'Chubut', 'Córdoba', 'Corrientes', 'Entre Ríos',
    'Formosa', 'Jujuy', 'La Pampa', 'La Rioja', 'Mendoza', 'Misiones', 'Neuquén', 'Río Negro', 'Salta', 'San Juan',
    'San Luis', 'Santa Cruz', 'Santa Fe', 'Santiago del Estero', 'Tierra del Fuego', 'Tucumán'];

  // Código postal (4 números) → provincia. Tabla COMPLETA del 1000 al 9999 en rangos contiguos, armada el
  // 18/10/2026 con Correo Argentino (consulta de localidades del día), la tabla CPA por calles de Correo,
  // GeoNames y Wikidata, y probada con los pedidos reales de la tienda. Script y datos en el respaldo
  // ~/respaldos-shopify/2026-10-18/envio-cp/ (cp-provincias-rangos.json + procesar.py).
  // Formato compacto: cada número es HASTA*100 + índice de la provincia en PROVINCIAS; cada rango empieza
  // donde terminó el anterior + 1 (el primero en 1000). Para corregir un código postal, regenerar con el script.
  var RANGOS_CP = [
    159900, 199901, 209920, 210007, 218820, 218905, 222220, 222301, 233320, 233405, 234020, 234121,
    234220, 234321, 235320, 235721, 239920, 240005, 240120, 240205, 240520, 240605, 240920, 243705,
    243820, 243905, 244120, 244205, 244320, 244405, 244720, 244805, 244920, 245005, 245420, 245505,
    245620, 246805, 246920, 249305, 249520, 249905, 250620, 250705, 250820, 251105, 251220, 251905,
    252120, 252205, 252320, 252505, 252720, 252805, 252920, 253005, 253120, 253205, 253320, 253405,
    253520, 259905, 260520, 260605, 260720, 260805, 260920, 261005, 261120, 261205, 261320, 261405,
    261520, 261605, 261820, 262105, 262220, 262505, 262620, 262905, 263120, 263205, 263320, 263405,
    263520, 263605, 263720, 263805, 264020, 264205, 264320, 269905, 270001, 270120, 272101, 272320,
    272401, 272620, 272701, 272920, 273101, 273220, 280801, 280907, 281001, 281107, 281501, 289907,
    291701, 292320, 299901, 306120, 306421, 309920, 319307, 319406, 319507, 319706, 319807, 319906,
    321907, 322006, 322107, 322206, 322307, 322406, 322507, 322606, 322907, 323206, 323307, 323606,
    324907, 325013, 329907, 330113, 330206, 333913, 334006, 334113, 334606, 334813, 334906, 335713,
    335806, 339013, 339106, 339913, 349906, 351503, 351620, 352403, 352608, 354703, 354808, 354903,
    355320, 355403, 355520, 355603, 355720, 355903, 356320, 356403, 356520, 356603, 356720, 356803,
    356920, 357103, 357220, 357303, 357720, 357903, 358120, 358203, 358920, 359103, 359320, 359503,
    359620, 359903, 364608, 364720, 364803, 369708, 371103, 371221, 373003, 373121, 373503, 373621,
    373903, 374121, 374203, 374321, 374403, 374521, 374603, 374721, 374803, 374921, 375103, 375321,
    375903, 376121, 376203, 376321, 376403, 376621, 379903, 389913, 399907, 401023, 401102, 412523,
    412616, 413823, 413902, 414923, 415002, 415323, 415416, 418323, 418521, 418823, 418921, 419116,
    419223, 419316, 419423, 419521, 419623, 419721, 419816, 419923, 423021, 423102, 423321, 423502,
    424121, 424223, 425621, 425723, 426221, 426323, 427521, 427623, 439921, 446016, 446109, 449916,
    450409, 450516, 450609, 450816, 451009, 451116, 451609, 451716, 451809, 452116, 452209, 454016,
    454109, 459916, 463209, 463316, 463609, 463716, 465009, 465216, 469909, 479902, 489905, 499916,
    524905, 525121, 525205, 525321, 525405, 525521, 525605, 525821, 525905, 526602, 527105, 527211,
    527305, 527811, 529905, 531411, 531702, 531811, 531902, 532011, 532102, 533011, 533302, 533811,
    534502, 534611, 534702, 539911, 546917, 547511, 549917, 567312, 568217, 568312, 568617, 569912,
    571618, 571711, 579918, 581905, 582007, 583005, 583118, 583405, 583518, 587105, 587218, 588005,
    588318, 588705, 588818, 599905, 600801, 600920, 603501, 603620, 603801, 603920, 609901, 610020,
    610105, 610201, 610320, 610405, 610501, 610620, 610701, 619905, 621510, 621918, 622210, 622401,
    622505, 622610, 622705, 622910, 623101, 623210, 623501, 623610, 623701, 623810, 623901, 624010,
    624401, 624810, 624901, 626810, 626918, 627305, 627410, 627605, 627718, 627805, 627918, 628010,
    628118, 633410, 633501, 633610, 633901, 634010, 634101, 634210, 634301, 634510, 634801, 638810,
    638918, 639910, 813201, 813310, 813701, 814015, 819901, 822410, 822501, 825410, 825501, 829910,
    830014, 830115, 830214, 830315, 830414, 830515, 830614, 830815, 830914, 831015, 832214, 833815,
    833910, 835914, 836115, 836214, 836415, 836514, 836915, 837614, 837715, 838514, 838615, 839914,
    840615, 840814, 843015, 843104, 850315, 850401, 850515, 850601, 850715, 850901, 851115, 851201,
    899915, 901004, 901119, 901204, 901319, 901404, 901519, 901604, 901919, 903904, 904119, 904604,
    904719, 904904, 905119, 905204, 905319, 929904, 940819, 941222, 941919, 942222, 943019, 943104,
    949919, 999904
  ];

  // Tarifas de Shopify al 15/10/2026. Sólo se usan con el carrito vacío.
  var TABLA_RESPALDO = {
    caba: [
      { n: 'A domicilio', p: 5400, t: 'llega en 24 h hábiles' },
      { n: 'Sucursal de Correo', p: 5549, t: '' }
    ],
    ba: [
      { n: 'A domicilio', p: 8200, t: '' },
      { n: 'Sucursal de Correo', p: 5549, t: '' }
    ],
    interior: [
      { n: 'A domicilio', p: 8600, t: '3 a 5 días hábiles' },
      { n: 'Sucursal de Correo', p: 6549, t: '3 a 5 días hábiles' }
    ]
  };

  function zona(prov) {
    if (prov === CABA) return 'caba';
    if (prov === 'Buenos Aires') return 'ba';
    return 'interior';
  }

  function nombreCorto(prov) {
    return prov === CABA ? 'CABA' : prov;
  }

  function escapar(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function etiqueta(nombre) {
    if (/sample/i.test(nombre)) return 'Envío del Sample Kit';
    if (/sucursal/i.test(nombre)) return 'Sucursal de Correo';
    if (/domicilio|local delivery/i.test(nombre)) return 'A domicilio';
    return escapar(String(nombre || 'Envío').slice(0, 40));
  }

  function plazo(tarifa, prov) {
    var d = tarifa.delivery_days;
    if (d && d.length === 2 && d[0] > 0) {
      if (d[0] === 1 && d[1] === 1) return 'llega en 24 h hábiles';
      return d[0] + (d[0] === d[1] ? '' : ' a ' + d[1]) + ' días hábiles';
    }
    var z = zona(prov);
    if (z === 'interior') return '3 a 5 días hábiles';
    if (z === 'caba' && !/sucursal/i.test(tarifa.name)) return 'llega en 24 h hábiles';
    return '';
  }

  // Formato argentino a mano (algunos navegadores de Instagram no traen el idioma es-AR).
  function plata(n) {
    return '$' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function leer(clave) {
    try { return window.localStorage.getItem(clave) || ''; } catch (e) { return ''; }
  }

  function guardar(clave, valor) {
    try { if (valor) window.localStorage.setItem(clave, valor); else window.localStorage.removeItem(clave); } catch (e) {}
  }

  // Deja sólo los números del código postal ("B1425ABC" → "1425"; "1.425" → "1425"; "01425" → "1425").
  // Si no quedan exactamente 4 números (vacío, "14250"), devuelve '' y se pide de nuevo.
  function limpiarCP(texto) {
    var d = String(texto || '').replace(/\D/g, '').replace(/^0+/, '');
    return /^\d{4}$/.test(d) ? d : '';
  }

  // fetch con tiempo máximo. propio=true conserva la cookie del carrito.
  function pedir(url, ms, propio) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, ms) : null;
    var opciones = { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } };
    if (propio) opciones.credentials = 'same-origin';
    else opciones.credentials = 'omit';
    return fetch(url, opciones)
      .then(function (r) { if (timer) clearTimeout(timer); return r; }, function (e) { if (timer) clearTimeout(timer); throw e; });
  }

  // Devuelve el nombre de provincia (de Shopify) para un código postal de 4 números, o '' si no se reconoce.
  function provinciaDeCP(cp) {
    if (!/^\d{4}$/.test(cp)) return '';
    var n = Number(cp);
    var lo = 0, hi = RANGOS_CP.length - 1;
    while (lo < hi) {
      var mid = (lo + hi) >> 1;
      if (Math.floor(RANGOS_CP[mid] / 100) < n) lo = mid + 1; else hi = mid;
    }
    var v = RANGOS_CP[lo];
    if (v === undefined || Math.floor(v / 100) < n || n < 1000) return '';
    return PROVINCIAS[v % 100] || '';
  }

  // Las dos instancias (ficha + cajón) comparten el pedido de tarifas si llega al mismo tiempo.
  var tarifasEnVuelo = {};

  // Esta llamada es la que deja prellenado el checkout: provincia correcta y el código postal REAL.
  function tarifasShopify(prov, cp) {
    var clave = prov + '|' + cp;
    if (tarifasEnVuelo[clave]) return tarifasEnVuelo[clave];
    var q = new URLSearchParams({ 'shipping_address[country]': 'Argentina', 'shipping_address[province]': prov, 'shipping_address[zip]': cp });
    var promesa = pedir('/cart/shipping_rates.json?' + q.toString(), TIMEOUT_PROPIO_MS, true)
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    tarifasEnVuelo[clave] = promesa;
    promesa.then(function () { setTimeout(function () { delete tarifasEnVuelo[clave]; }, 1500); });
    return promesa;
  }

  class ButtomCalculaEnvio extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._alClic = function (e) {
        if (e.target && e.target.closest && e.target.closest('.buttom-ce__ver')) {
          e.preventDefault();
          self.tomarCP();
        }
      };
      this._alTecla = function (e) {
        if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('.buttom-ce__input')) {
          e.preventDefault();
          self.tomarCP();
        }
      };
      // Otra instancia (ficha ↔ cajón) cambió el código postal: se copia y se recalcula.
      this._alCambiarOtro = function (e) {
        if (e.detail && e.detail.origen === self) return;
        var input = self.querySelector('.buttom-ce__input');
        if (input && e.detail) input.value = e.detail.cp || '';
        self.calcular();
      };
      this._alActualizarCarrito = function () {
        clearTimeout(self._timer);
        self._timer = setTimeout(function () { if (self.isConnected) self.calcular(); }, 300);
      };
      this.addEventListener('click', this._alClic);
      this.addEventListener('keydown', this._alTecla);
      document.addEventListener('cart:update', this._alActualizarCarrito);
      document.addEventListener('buttom:cp', this._alCambiarOtro);
      setTimeout(function () { if (self.isConnected) self.calcular(); }, 0);
    }

    disconnectedCallback() {
      clearTimeout(this._timer);
      this.removeEventListener('click', this._alClic);
      this.removeEventListener('keydown', this._alTecla);
      document.removeEventListener('cart:update', this._alActualizarCarrito);
      document.removeEventListener('buttom:cp', this._alCambiarOtro);
    }

    // La persona tocó "Ver costo" (o Enter): se guarda el código postal y se avisa a la otra instancia.
    tomarCP() {
      var input = this.querySelector('.buttom-ce__input');
      if (!input) return;
      var cp = limpiarCP(input.value);
      if (!cp) {
        this.mensaje('Escribí los 4 números de tu código postal, sin letras (por ejemplo 1425).');
        input.focus();
        return;
      }
      input.value = cp;
      guardar(CLAVE_CP, cp);
      document.dispatchEvent(new CustomEvent('buttom:cp', { detail: { origen: this, cp: cp } }));
      this.calcular();
    }

    // Código postal a usar: el escrito/guardado, o el de la cuenta.
    obtenerCP() {
      var input = this.querySelector('.buttom-ce__input');
      var escrito = input ? limpiarCP(input.value) : '';
      if (escrito) return escrito;
      var guardado = limpiarCP(leer(CLAVE_CP));
      if (guardado) return guardado;
      return limpiarCP(this.getAttribute('data-cp-cuenta') || '');
    }

    // Nunca deja una promesa sin atrapar: si algo falla, queda la línea general y la página sigue.
    calcular() {
      var self = this;
      return this._calcular().catch(function () { try { self.resumen(TEXTO_SIN_CP, 'Calcular'); } catch (e) {} });
    }

    async _calcular() {
      var input = this.querySelector('.buttom-ce__input');
      var salida = this.querySelector('.buttom-ce__resultado');
      if (!input || !salida) return;
      var pedido = (this._pedido || 0) + 1;
      this._pedido = pedido;

      var cp = this.obtenerCP();
      if (!cp) {
        salida.innerHTML = '';
        this.provincia('');
        this.resumen(TEXTO_SIN_CP, 'Calcular');
        this.avisar(null, false, '', '');
        return;
      }
      if (!input.value) input.value = cp;

      var prov = provinciaDeCP(cp);
      if (pedido !== this._pedido || !this.isConnected) return;
      if (!prov) {
        guardar(CLAVE_CP, '');
        this.provincia('');
        this.mensaje('No reconocemos ese código postal. Probá con el de tu localidad.');
        this.resumen(TEXTO_SIN_CP, 'Calcular');
        this.avisar(null, false, '', cp);
        return;
      }
      this.provincia(prov);
      if (!salida.innerHTML || salida.querySelector('.buttom-ce__nota--aviso')) salida.textContent = 'Calculando…';

      var filas = null;
      var sinEnvio = false;
      var gratis = false;
      try {
        var rc = await pedir('/cart.js', TIMEOUT_PROPIO_MS, true);
        var carrito = rc.ok ? await rc.json() : null;
        if (carrito) {
          var bruto = 0;
          (carrito.items || []).forEach(function (i) { bruto += i.original_line_price || 0; });
          gratis = bruto >= ENVIO_GRATIS_DESDE;
          if (carrito.item_count > 0) {
            var j = await tarifasShopify(prov, cp);
            if (j && Array.isArray(j.shipping_rates)) {
              filas = j.shipping_rates.map(function (x) {
                var p = Number(x.price);
                return isFinite(p) ? { n: etiqueta(x.name), p: p, t: plazo(x, prov) } : null;
              }).filter(Boolean);
              if (!filas.length) { filas = null; sinEnvio = true; }
            }
          }
        }
      } catch (e) {}
      if (pedido !== this._pedido || !this.isConnected) return;

      if (sinEnvio) {
        salida.innerHTML = '<p class="buttom-ce__nota">El costo de envío se confirma al finalizar la compra.</p>';
        this.resumen('Envío a ' + nombreCorto(prov), 'Cambiar');
        this.avisar(null, false, prov, cp);
        return;
      }
      if (!filas) filas = TABLA_RESPALDO[zona(prov)].slice();
      filas.sort(function (a, b) { return a.p - b.p; });

      var html = filas.map(function (f) {
        var precio = gratis || f.p === 0 ? 'Gratis' : plata(f.p);
        return '<div class="buttom-ce__fila"><span>' + f.n + (f.t ? '<small>' + f.t + '</small>' : '') + '</span><strong>' + precio + '</strong></div>';
      }).join('');
      html += gratis
        ? '<p class="buttom-ce__nota">Tu compra tiene envío gratis.</p>'
        : '<p class="buttom-ce__nota">Gratis desde $80.000.</p>';
      salida.innerHTML = html;
      var nombre = nombreCorto(prov);
      this.resumen(gratis || filas[0].p === 0 ? 'Envío gratis a ' + nombre : 'Envío a ' + nombre + ' desde ' + plata(filas[0].p), 'Cambiar');
      this.avisar(filas, gratis, prov, cp);
    }

    // Avisa el resultado (lo usa la landing de Black Orchid para sumar el envío al total).
    avisar(filas, gratis, prov, cp) {
      this.dispatchEvent(new CustomEvent('buttom:envio', { bubbles: true, detail: { provincia: prov || '', cp: cp || '', filas: filas, gratis: !!gratis } }));
    }

    // Línea plegada + la palabra de acción ("Calcular" / "Cambiar").
    resumen(texto, accion) {
      var r = this.querySelector('.buttom-ce__resumen-texto');
      if (r) r.textContent = texto;
      var a = this.querySelector('.buttom-ce__accion');
      if (a) a.textContent = accion || '';
    }

    // Debajo del campo: a qué provincia corresponde el código postal.
    provincia(prov) {
      var p = this.querySelector('.buttom-ce__prov');
      if (!p) return;
      p.hidden = !prov;
      p.textContent = prov ? 'Provincia: ' + nombreCorto(prov) : '';
    }

    mensaje(texto) {
      var salida = this.querySelector('.buttom-ce__resultado');
      if (salida) salida.innerHTML = '<p class="buttom-ce__nota buttom-ce__nota--aviso">' + escapar(texto) + '</p>';
    }
  }

  window.customElements.define('buttom-calcula-envio', ButtomCalculaEnvio);
})();

/*
  BUTTOM 19/10/2026: arreglo del formato de precios de la app Hoppy (barra "Sumando $X tenés envío gratis").
  La tienda usa el formato de moneda sin decimales con punto de miles (${{amount_no_decimals_with_comma_separator}}),
  pero Hoppy no reconoce ese formato y escribe "$50,000" (coma de miles, estilo inglés). Acá se cambia esa coma por
  punto SÓLO dentro de sus precios (.futureblink-price-text). Si algún día Hoppy lo corrige, esto no hace nada.
*/
(function () {
  if (window.__buttomArregloHoppy) return;
  window.__buttomArregloHoppy = true;
  var COMA_MILES = /(\d),(?=\d{3}(?!\d))/g;

  function arreglar(raiz) {
    var precios = (raiz && raiz.querySelectorAll) ? raiz.querySelectorAll('.futureblink-price-text') : [];
    for (var i = 0; i < precios.length; i++) {
      var tw = document.createTreeWalker(precios[i], NodeFilter.SHOW_TEXT);
      var n;
      while ((n = tw.nextNode())) {
        var t = n.nodeValue;
        if (t && t.indexOf(',') >= 0 && /\d,\d{3}(?!\d)/.test(t)) n.nodeValue = t.replace(COMA_MILES, '$1.');
      }
    }
  }

  var pendiente = false;
  function programar() {
    if (pendiente) return;
    pendiente = true;
    (window.requestAnimationFrame || setTimeout)(function () { pendiente = false; arreglar(document.body); });
  }

  function iniciar() {
    arreglar(document.body);
    if (typeof MutationObserver !== 'function') return;
    new MutationObserver(programar).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
